import script from "./employee-my-documents.vue?vue&type=script&setup=true&lang=js"
export * from "./employee-my-documents.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__